import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const exclamationCircle: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M2.984-10.187A5.9 5.9 0 0 1 6-11q1.64.001 3.016.813a5.9 5.9 0 0 1 2.172 2.171Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187M7-1.266V-2.75a.22.22 0 0 0-.078-.172A.2.2 0 0 0 6.766-3h-1.5a.26.26 0 0 0-.188.078A.23.23 0 0 0 5-2.75v1.484c0 .075.023.137.078.188.05.055.113.078.188.078h1.5a.19.19 0 0 0 .156-.078A.26.26 0 0 0 7-1.266m-.016-2.687.141-4.844a.16.16 0 0 0-.078-.14A.32.32 0 0 0 6.859-9H5.141a.3.3 0 0 0-.188.063c-.055.03-.078.078-.078.14l.14 4.844q-.002.082.079.14.075.064.187.063H6.72q.106 0 .187-.062.077-.06.078-.141m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};

export const exclamationTriangle: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M8-1.266V-2.75a.22.22 0 0 0-.078-.172A.22.22 0 0 0 7.75-3h-1.5a.24.24 0 0 0-.172.078A.2.2 0 0 0 6-2.75v1.484c0 .075.023.137.078.188.05.055.11.078.172.078h1.5c.07 0 .129-.023.172-.078A.26.26 0 0 0 8-1.266m-.016-2.921.141-3.579a.2.2 0 0 0-.078-.156A.3.3 0 0 0 7.859-8H6.141q-.083 0-.188.078a.2.2 0 0 0-.078.172l.14 3.563q-.002.081.079.14Q6.17-4 6.28-4H7.72q.105 0 .187-.047.077-.059.078-.14m-.109-7.297 6 11c.188.336.18.664-.016 1a.9.9 0 0 1-.359.343A.96.96 0 0 1 13 1H1A.95.95 0 0 1 .5.86 1.04 1.04 0 0 1 .14.515c-.195-.336-.202-.664-.015-1l6-11q.141-.235.375-.375a.983.983 0 0 1 1.375.375m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0.01 12)"
    />
  ),
  svgProps: {
    height: "13",
    width: "14.022",
  }
};